

























































































import Vue from 'vue';
import DatePicker from 'vue2-datepicker';
import vSelect from 'vue-select';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/zh-tw';
const Ripple = require('vue-ripple-directive');
import moment from 'moment';
import axios from 'axios';

export default Vue.extend({
  components: {
    DatePicker,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    const range = [moment().subtract(1, 'days').valueOf(), moment().valueOf()];
    return {
      display: false,
      columns: Array<any>(),
      statRows: [],
      rows: [],
      instruments: Array<any>(),
      form: {
        instrument: {},
        range,
      },
    };
  },
  mounted() {
    this.getInstruments();
  },
  methods: {
    getInstruments() {
      axios.get('/Instruments').then(res => {
        const ret = res.data;
        this.instruments = ret;
        if (this.instruments.length !== 0) {
          this.form.instrument = this.instruments[0]._id;
        }
      });
    },
    async query() {
      this.display = true;
      const url = `/InstrumentStatusReport/${this.form.instrument}/${this.form.range[0]}/${this.form.range[1]}`;
      const res = await axios.get(url);
      this.handleReport(res.data);
    },
    handleReport(report: any) {
      this.columns.splice(0, this.columns.length);

      this.columns.push({
        key: 'time',
        label: '時間',
        sortable: true,
      });

      for (let i = 0; i < report.columnNames.length; i++) {
        this.columns.push({
          key: `cellData[${i}].v`,
          label: `${report.columnNames[i]}`,
          sortable: true,
          stickyColumn: true,
        });
      }
      for (const row of report.rows) {
        row.time = moment(row.time).format('lll');
      }
      this.rows = report.rows;
      this.statRows = report.statRows;
    },
  },
});
